import "./TeaserTemplate.scss";
import { transformStatus, formatFloat } from "../../../utils/project";
import logo from "../../../assets/logo-white.svg";
import solarPanel from "../../../assets/home/solar-teaser.webp";
import windPanel from "../../../assets/home/wind-teaser.webp";
import storagePanel from "../../../assets/home/storage-teaser_resized.jpg";
import solarStoragePanel from "../../../assets/home/solar-storage-teaser.webp";

import solarIco from "../../../assets/home/ico-panels.svg";
import storageIco from "../../../assets/home/ico-battery.svg";
import windIco from "../../../assets/home/ico-wind.svg";
import hydrogenIco from "../../../assets/home/ico-hydrogen.svg";
import icoTeaserTime from "../../../assets/home/ico-teaser-time.svg";

// Traducciones simples (mismo formato que el frontend de nrdeal-web)
const translations = {
  en: {
    TeaserDocument: {
      projectTeaser: "Project Teaser",
      expectedRTB: "Expected RTB",
      expectedCOD: "Expected COD",
      theSeller: "The Seller",
      theProject: "The Project",
      general: "General",
      technology: "Technology",
      technologyType: "Technology Type",
      dcPower: "DC Power",
      acPower: "AC Power",
      annualProduction: "Annual Production",
      specificEnergyProduction: "Specific Energy Production",
      energyCapacity: "Energy Capacity",
      storageDuration: "Storage duration",
      power: "Power",
      transaction: "Transaction",
      routeToMarket: "Route to Market",
      expectedEnergySalePrice: "Expected Energy Sale price",
      contractDuration: "Contract Duration",
      dealType: "Deal Type",
      percentOfCapitalRequired: "Percent of Capital Required",
      storageRevenue: "Storage Revenue",
      permitting: "Permitting",
      preliminaryAdministrativeAuthorization:
        "Preliminary Administrative Authorization",
      constructionAdministrativePermit: "Construction Administrative Permit",
      transformetStationSubstationPermit:
        "Transformet Station/Substation Permit",
      environmentalPermit: "Environmental Permit",
      environmentalImpactAssessmentEIA: "Environmental Impact Assesment (EIA)",
      observations: "Observations",
      landRights: "Land Rights",
      landRightsStatus: "Land Rights Status",
      area: "Area",
      percentageOfLandSecured: "Percentage of land secured",
      typeOfLandRights: "Type of Land Rights",
      numberOfLandOwners: "Number of Land Owners",
      annualLeasePrice: "Annual Lease Price",
      durationOfRights: "Duration of Rights",
      otherLandPaymentsCompensation: "Other Land Payments/Compensation",
      gridConnection: "Grid Connection",
      gridConnectionStatus: "Grid Connection Status",
      approvedExpectedConnectionDate: "Approved/Expected Connection Date",
      transmissionSystemOwner: "Transmission System Owner",
      connectionType: "Connection Type",
      connectionLineLength: "Connection Line Length",
      interconnectionVoltage: "Interconnection Voltage",
      approvedExportCapacity: "Approved Export Capacity",
      gridConnectionCost: "Grid Connection Cost",
      gridConnectionAccess: "Grid Connection Access (IVA)",
      capexOpex: "CAPEX & OPEX",
      capexEPCEstimatedPrice: "CAPEX - EPC Estimated Price",
      opex: "OPEX",
      sellerServices: "Seller Services",
      epcServices: "EPC Services",
      omServices: "O&M Services",
      developmentStatus: "Development Status",
    },
  },
  es: {
    TeaserDocument: {
      projectTeaser: "Project Teaser",
      expectedRTB: "Expected RTB",
      expectedCOD: "Expected COD",
      theSeller: "The Seller",
      theProject: "The Project",
      general: "General",
      technology: "Technology",
      technologyType: "Technology Type",
      dcPower: "DC Power",
      acPower: "AC Power",
      annualProduction: "Annual Production",
      specificEnergyProduction: "Specific Energy Production",
      energyCapacity: "Energy Capacity",
      storageDuration: "Storage duration",
      power: "Power",
      transaction: "Transaction",
      routeToMarket: "Route to Market",
      expectedEnergySalePrice: "Expected Energy Sale price",
      contractDuration: "Contract Duration",
      dealType: "Deal Type",
      percentOfCapitalRequired: "Percent of Capital Required",
      storageRevenue: "Storage Revenue",
      permitting: "Permitting",
      preliminaryAdministrativeAuthorization:
        "Preliminary Administrative Authorization",
      constructionAdministrativePermit: "Construction Administrative Permit",
      transformetStationSubstationPermit:
        "Transformet Station/Substation Permit",
      environmentalPermit: "Environmental Permit",
      environmentalImpactAssessmentEIA: "Environmental Impact Assesment (EIA)",
      observations: "Observations",
      landRights: "Land Rights",
      landRightsStatus: "Land Rights Status",
      area: "Area",
      percentageOfLandSecured: "Percentage of land secured",
      typeOfLandRights: "Type of Land Rights",
      numberOfLandOwners: "Number of Land Owners",
      annualLeasePrice: "Annual Lease Price",
      durationOfRights: "Duration of Rights",
      otherLandPaymentsCompensation: "Other Land Payments/Compensation",
      gridConnection: "Grid Connection",
      gridConnectionStatus: "Grid Connection Status",
      approvedExpectedConnectionDate: "Approved/Expected Connection Date",
      transmissionSystemOwner: "Transmission System Owner",
      connectionType: "Connection Type",
      connectionLineLength: "Connection Line Length",
      interconnectionVoltage: "Interconnection Voltage",
      approvedExportCapacity: "Approved Export Capacity",
      gridConnectionCost: "Grid Connection Cost",
      gridConnectionAccess: "Grid Connection Access (IVA)",
      capexOpex: "CAPEX & OPEX",
      capexEPCEstimatedPrice: "CAPEX - EPC Estimated Price",
      opex: "OPEX",
      sellerServices: "Seller Services",
      epcServices: "EPC Services",
      omServices: "O&M Services",
      developmentStatus: "Development Status",
    },
  },
};

// Helper para obtener traducciones
const t = (key) => {
  const lang = localStorage.getItem("i18nextLng") || "en";
  const langTranslations = translations[lang] || translations["en"];
  const keys = key.split(".");
  let value = langTranslations;
  for (const k of keys) {
    if (value && typeof value === "object") {
      value = value[k];
    } else {
      return key; // Si no encuentra, devuelve la clave
    }
  }
  return value || key;
};

export default function TeaserTemplate({ project }) {
  const missingVale = "N/A";
  const lang = localStorage.getItem("i18nextLng") || "en";

  const isSolarStorage =
    project?.technology?.length === 2 &&
    project?.technology?.every(
      (t) => t.type === "solar" || t.type === "storage",
    );

  const isWind =
    project?.technology?.length === 1 &&
    project?.technology?.[0]?.type === "wind";

  const technologies = isSolarStorage
    ? project?.technology ?? []
    : [project?.technology?.[0]];

  // Misma lógica de iconos que en el frontend: siempre usar los iconos locales por tipo
  const logosUrl = [];
  for (const tech of technologies) {
    if (tech?.type === "solar") logosUrl.push(solarIco);
    if (tech?.type === "storage") logosUrl.push(storageIco);
    if (tech?.type === "wind") logosUrl.push(windIco);
    if (tech?.type === "hydrogen") logosUrl.push(hydrogenIco);
  }

  // Usar las imágenes locales (igual que en el frontend)
  let imageTeaser = solarPanel;
  if (isSolarStorage) imageTeaser = solarStoragePanel;
  else if (isWind) imageTeaser = windPanel;
  else if (project?.technology?.[0]?.type === "storage")
    imageTeaser = storagePanel;

  const Header = () => {
    return (
      <div className="header-teaser d-flex justify-content-between align-items-center">
        <label
          className="text-uppercase text-white fw-bold"
          style={{ fontWeight: "bold", fontSize: 16 }}
        >
          {t("TeaserDocument.projectTeaser")}
        </label>
        <img src={logo} loading="lazy" alt="Nrdeal" width={90} />
      </div>
    );
  };

  const Footer = () => {
    return (
      <div className="footer-teaser d-flex justify-content-between align-items-center">
        <label className="d-flex gap-2 align-items-center">
          <i className="bi bi-global" />
          nrdeal.com
        </label>

        <label className="d-flex gap-2 align-items-center">
          <i className="bi bi-person" />
          contact@nrdeal.com
        </label>
      </div>
    );
  };

  const MainInfoTeaser = ({ bottomLine = false }) => {
    return (
      <div
        className={`d-flex justify-content-between align-items-end ${
          bottomLine ? "bottom-line" : ""
        }`}
      >
        <div className="d-flex gap-3 mb-1 align-items-center">
          {logosUrl?.map((techLogo, index) => (
            <img
              key={index}
              src={techLogo}
              alt="Tech logo"
              height={40}
              style={{ marginRight: 12 }}
            />
          ))}

          <div className="d-flex flex-column">
            <span className="title-main-info fw-bold">
              {project?.fakeTitle}
            </span>
            <span className="title-main-info fw-bold">
              {transformStatus?.[project?.developmentStatus?.title?.[lang]]}
            </span>
            <span className="span-info">
              {project?.country?.name}{" "}
              {project?.province ? `(${project?.province})` : ""}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column mb-1">
          <div className="d-flex">
            <label
              className="span-info fw-bold"
              style={{ marginRight: 12, fontWeight: "bold" }}
            >
              {t("TeaserDocument.expectedRTB")}
            </label>
            <span className="span-info fw-bold" style={{ fontWeight: "bold" }}>
              {project?.rtbDate}
            </span>
          </div>
          <div className="d-flex">
            <label
              className="span-info fw-bold"
              style={{ marginRight: 12, fontWeight: "bold" }}
            >
              {t("TeaserDocument.expectedCOD")}
            </label>
            <span className="span-info fw-bold" style={{ fontWeight: "bold" }}>
              {project?.codDate}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const SellerInfo = () => {
    return (
      <div style={{ marginTop: 20, marginBottom: 10 }}>
        <h5 className="fw-bold title-description mt-1">
          {t("TeaserDocument.theSeller")}
        </h5>
        <span className="p-info">{project?.seller?.description ?? "-"}</span>
      </div>
    );
  };

  const ProjectInfo = () => {
    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <h5 className="fw-bold title-description">
          {t("TeaserDocument.theProject")}
        </h5>
        <span className="p-info mb-1">{project?.description ?? "-"}</span>
      </div>
    );
  };

  const SolarInfo = ({ solar, index }) => {
    const techName =
      solar?.type?.charAt(0).toUpperCase() + solar?.type?.slice(1);
    const secondTech = index > 0;

    return (
      <div>
        {!secondTech && (
          <label className="text-uppercase title-section mb-2">
            {t("TeaserDocument.general")}
          </label>
        )}
        <div
          className={`${secondTech ? "" : "top-line"} d-flex flex-column gap-1`}
        >
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.technology")} {secondTech ? "(II)" : ""}
            </label>
            <span className="w-25 span-info">{techName}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.technologyType")}
            </label>
            <span className="w-25 span-info">{solar?.techType}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.dcPower")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(solar?.dcPower) + " MWp"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.acPower")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(solar?.acPower) + " MW"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.annualProduction")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(solar?.anualEnergyProd) + " MWh/year"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.specificEnergyProduction")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(solar?.capacityP50) + " kWh/kWp/year"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const StorageInfo = ({ storage, index }) => {
    const techName =
      storage?.type?.charAt(0).toUpperCase() + storage?.type?.slice(1);
    const secondTech = index > 0;

    return (
      <div>
        {!secondTech && (
          <label className="text-uppercase title-section mb-2">
            {t("TeaserDocument.general")}
          </label>
        )}
        <div
          className={`${secondTech ? "" : "top-line"} d-flex flex-column gap-1`}
        >
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.technology")} {secondTech ? "(II)" : ""}{" "}
            </label>
            <span className="w-25 span-info">{techName}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.technologyType")}
            </label>
            <span className="w-25 span-info">{storage?.techType}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.acPower")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(storage?.acPower) + " MW"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.energyCapacity")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(storage?.anualEnergyProd) + " MWh"}
            </span>
          </div>
          {!secondTech && (
            <div className="d-flex justify-content-between">
              <label className="w-75 label-info">
                {t("TeaserDocument.storageDuration")}
              </label>
              <span className="w-25 span-info">
                {formatFloat(storage?.storeDuration) + " h"}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const WindInfo = ({ wind }) => {
    const techName = wind?.type?.charAt(0).toUpperCase() + wind?.type?.slice(1);

    return (
      <div>
        <label className="text-uppercase title-section mb-2">
          {t("TeaserDocument.general")}
        </label>
        <div className="top-line d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.technology")}
            </label>
            <span className="w-25 span-info">{techName}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.technologyType")}
            </label>
            <span className="w-25 span-info">{wind?.techType}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.power")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(wind?.power) + " MW"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.annualProduction")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(wind?.anualEnergyProd) + " MWh/year"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const HydrogenInfo = ({ hydrogen }) => {
    const techName =
      hydrogen?.type?.charAt(0).toUpperCase() + hydrogen?.type?.slice(1);

    return (
      <div>
        <label className="text-uppercase title-section mb-2">
          {t("TeaserDocument.general")}
        </label>
        <div className="top-line d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.technology")}
            </label>
            <span className="w-25 span-info">{techName}</span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.power")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(hydrogen?.power) + " MWe"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.annualProduction")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(hydrogen?.anualEnergyProd) + " MWh/year"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const TransactionInfo = () => {
    const showStorage = technologies?.some((tech) => tech?.type === "storage");

    return (
      <div>
        <label className="text-uppercase title-section mb-2">
          {t("TeaserDocument.transaction")}
        </label>
        <div className="top-line d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.routeToMarket")}
            </label>
            <span className="w-25 span-info">
              {project?.transactionInfo?.routeMarket}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.expectedEnergySalePrice")}
            </label>
            <span className="w-25 span-info">
              {project?.transactionInfo?.energyExpectedSale
                ? project?.transactionInfo?.energyExpectedSale + " €/MWh"
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.contractDuration")}
            </label>
            <span className="w-25 span-info">
              {project?.transactionInfo?.contractYears
                ? formatFloat(project?.transactionInfo?.contractYears) +
                  " years"
                : missingVale}
            </span>
          </div>
        </div>

        {project?.transactionInfo?.routeMarket2 && (
          <>
            <div className="d-flex flex-column gap-1">
              <div className="d-flex justify-content-between mt-3">
                <label className="w-75 label-info">
                  {t("TeaserDocument.routeToMarket")} {"(II)"}
                </label>
                <span className="w-25 span-info">
                  {project?.transactionInfo?.routeMarket2
                    ? project?.transactionInfo?.routeMarket2
                    : missingVale}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <label className="w-75 label-info">
                  {t("TeaserDocument.expectedEnergySalePrice")}
                </label>
                <span className="w-25 span-info">
                  {project?.transactionInfo?.energyExpectedSale2
                    ? project?.transactionInfo?.energyExpectedSale2 + " €/MWh"
                    : missingVale}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <label className="w-75 label-info">
                  {t("TeaserDocument.contractDuration")}
                </label>
                <span className="w-25 span-info">
                  {project?.transactionInfo?.contractYears2
                    ? formatFloat(project?.transactionInfo?.contractYears2) +
                      " years"
                    : missingVale}
                </span>
              </div>
            </div>
          </>
        )}
        <div className=" d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-3">
            <label className="w-75 label-info">
              {t("TeaserDocument.dealType")}
            </label>
            <span className="w-25 span-info">
              {project?.transactionInfo?.dealSeeking}
            </span>
          </div>

          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.percentOfCapitalRequired")}
            </label>
            <span className="w-25 span-info">
              {project?.transactionInfo?.capitalRequired
                ? formatFloat(project?.transactionInfo?.capitalRequired) + " %"
                : missingVale}
            </span>
          </div>
          {showStorage && (
            <div className="d-flex justify-content-between">
              <label className="w-75 label-info">
                {t("TeaserDocument.storageRevenue")}
              </label>
              <span className="w-25 span-info">
                {project?.transactionInfo?.storageRevenue?.length > 0
                  ? project?.transactionInfo?.storageRevenue?.join(", ")
                  : missingVale}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  {
    /* ------------------ PAGE 2 ------------------ */
  }

  const PermittingInfo = () => {
    return (
      <div className="pdf-section">
        <label className="title-section mb-2">
          {t("TeaserDocument.permitting")}
        </label>
        <div className="top-line d-flex flex-column">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.preliminaryAdministrativeAuthorization")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.preAdminPermit}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.constructionAdministrativePermit")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.constAdminPermit}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.transformetStationSubstationPermit")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.transformerPermition
                ? project?.infoStatus?.transformerPermition
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.environmentalPermit")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.envStatus}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.environmentalImpactAssessmentEIA")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.envImpacAsses}
            </span>
          </div>

          <div className="d-flex flex-column">
            <label className="label-info">
              {t("TeaserDocument.observations")}
            </label>
            <span className="span-info-sm">
              {project?.infoStatus?.observationEnv || "-"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const LandRights = () => {
    return (
      <div className="pdf-section">
        <label className="title-section mb-2">
          {t("TeaserDocument.landRights")}
        </label>
        <div className="top-line d-flex flex-column">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.landRightsStatus")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.landStatus}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.area")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(project?.infoStatus?.areaHectars) + " ha"}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.percentageOfLandSecured")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.percLand
                ? `${formatFloat(project?.infoStatus?.percLand)} %`
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.typeOfLandRights")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.typeLand}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.numberOfLandOwners")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.numLandOwners
                ? project?.infoStatus?.numLandOwners
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.annualLeasePrice")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.landLeasePriceYear
                ? project?.infoStatus?.landLeasePriceYear + "€/ha/year"
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.durationOfRights")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(project?.infoStatus?.landLeaseDuration) + " years"}
            </span>
          </div>

          <div className="d-flex flex-column">
            <label className="label-info">
              {t("TeaserDocument.otherLandPaymentsCompensation")}
            </label>
            <span className="span-info-sm">
              {project?.infoStatus?.otherPayComp || "-"}
            </span>
          </div>

          <div className="d-flex flex-column">
            <label className="label-info">
              {t("TeaserDocument.observations")}
            </label>
            <span className="span-info-sm">
              {project?.infoStatus?.observationLand || "-"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const GridPermitting = () => {
    return (
      <div className="pdf-section">
        <label className="title-section mb-2">
          {t("TeaserDocument.gridConnection")}
        </label>
        <div className="top-line d-flex flex-column">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.gridConnectionStatus")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.gridStatus}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.approvedExpectedConnectionDate")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.interconnectionAgreement}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <label className="w-75 label-info">
              {t("TeaserDocument.transmissionSystemOwner")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.transmissionSystemOwner
                ? project?.infoStatus?.transmissionSystemOwner
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.connectionType")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.conectionType}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.connectionLineLength")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.lineDistance
                ? `${formatFloat(project?.infoStatus?.lineDistance)} km`
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.interconnectionVoltage")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(project?.infoStatus?.interconnectionVoltage) + " kV"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.approvedExportCapacity")}
            </label>
            <span className="w-25 span-info">
              {formatFloat(project?.infoStatus?.approvedExportCapacity) +
                " MWac"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.gridConnectionCost")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.gridConnectionCost
                ? `${formatFloat(
                    project?.infoStatus?.gridConnectionCost,
                  )} k€/MW`
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.gridConnectionAccess")}
            </label>
            <span className="w-25 span-info">
              {project?.infoStatus?.gridConnectionIva
                ? project?.infoStatus?.gridConnectionIva
                : missingVale}
            </span>
          </div>
          <div className="d-flex flex-column">
            <label className="label-info">
              {t("TeaserDocument.observations")}
            </label>
            <span className="span-info-sm">
              {project?.infoStatus?.observationGrid || "-"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  {
    /* ------------------ PAGE 3 ------------------ */
  }
  const CapexAndOpexInfo = () => {
    return (
      <div>
        <label className="text-uppercase title-section mb-2">
          {t("TeaserDocument.capexOpex")}
        </label>
        <div className="top-line d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.capexEPCEstimatedPrice")}
            </label>
            <span className="w-25 span-info">
              {project?.capexOpex?.capexPrice
                ? `${formatFloat(project?.capexOpex?.capexPrice)} k€/MW`
                : missingVale}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.opex")}
            </label>
            <span className="w-25 span-info">
              {project?.capexOpex?.opexPrice
                ? `${formatFloat(project?.capexOpex?.opexPrice)} k€/MW`
                : missingVale}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const SellerServices = () => {
    return (
      <div>
        <label className="text-uppercase title-section mb-2">
          {t("TeaserDocument.sellerServices")}
        </label>
        <div className="top-line d-flex flex-column gap-1">
          <div className="d-flex justify-content-between mt-2">
            <label className="w-75 label-info">
              {t("TeaserDocument.epcServices")}
            </label>
            <span className="w-25 span-info">
              {project?.capexOpex?.capexService ? `Yes` : "No"}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <label className="w-75 label-info">
              {t("TeaserDocument.omServices")}
            </label>
            <span className="w-25 span-info">
              {project?.capexOpex?.opexServices ? `Yes` : "No"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const TransactionDealFlow = () => {
    return (
      <div
        className="deal-flow-box d-flex flex-column"
        style={{ marginTop: "150px" }}
      >
        <div className="d-flex align-items-center justify-content-between mb-2">
          <label className="text-uppercase title-main-info">
            TRANSACTION DEAL FLOW
          </label>
          <img src={icoTeaserTime} alt="deal-flow" height={26} />
        </div>

        <div className="deal-flow-step">
          <span className="span-info-sm semibold">1. REQUEST CONNECTION</span>
          <p className="span-info-sm">
            From the project profile, request a connection with the Seller. To
            ensure confidentiality, at this stage all users and projects operate
            under randomized names, ensuring privacy and data protection of the
            users through the process.
          </p>
        </div>

        <div className="deal-flow-step">
          <span className="span-info-sm semibold">2. CONNECTION & NDA</span>
          <p className="span-info-sm">
            Once the connection is approved by the Seller you will receive a
            notification, and the transaction deal flow will be launched in{" "}
            <i className="my-i">My Deals</i> section. You are now ready to
            negotiate and sign the NDA with the seller.
          </p>
        </div>

        <div className="deal-flow-step">
          <span className="span-info-sm semibold">
            3. ACCESS PROJECT VIRTUAL DATA ROOM (VDR)
          </span>
          <p className="span-info-sm">
            Once both parties completed the NDA to guarantee full
            confidentiality between parties during the transaction process,
            access to the VDR will be granted to the Buyer. You can now explore
            all the Project's technical, legal, and financial documentation. The
            documentation is stored in an encrypted and controlled environment.
          </p>
        </div>

        <div className="deal-flow-step">
          <span className="span-info-sm semibold">
            4. SUBMIT NON-BIDING OFFER (NBO)
          </span>
          <p className="span-info-sm">
            When you are ready send your NBO securely through a dedicated form
            available in <i className="my-i">My Deals</i>, ensuring transparency
            and data integrity.
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="primary-color-font d-flex flex-column">
      <div className="pdf-page-content">
        <div style={{ flex: 1 }}>
          <Header />
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column gap-3 w-75 padding-left-top-rigth">
              <MainInfoTeaser bottomLine={true} />
              <div className="d-flex flex-column gap-3">
                <SellerInfo />
                <ProjectInfo />
                {technologies.map((tech, index) => {
                  if (tech?.type === "solar")
                    return <SolarInfo key={index} solar={tech} index={index} />;
                  if (tech?.type === "storage")
                    return (
                      <StorageInfo key={index} storage={tech} index={index} />
                    );
                  if (tech?.type === "wind")
                    return <WindInfo key={index} wind={tech} index={index} />;
                  if (tech?.type === "hydrogen")
                    return (
                      <HydrogenInfo key={index} hydrogen={tech} index={index} />
                    );
                })}
                <TransactionInfo />
              </div>
            </div>
            <div className="img-tech w-25">
              <img src={imageTeaser} alt="Solar panels" />
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <div className="page-break"></div>
      <div className="pdf-page-content">
        <div style={{ flex: 1 }}>
          <Header />
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column gap-3 w-75 padding-left-top-rigth">
              <MainInfoTeaser />
              <div className="d-flex flex-column gap-2">
                <label className="text-uppercase title-main-info fw-bold secondary-color-font">
                  {t("TeaserDocument.developmentStatus")}
                </label>
                <PermittingInfo />
                <LandRights />
                <GridPermitting />
              </div>
            </div>
            <div className="img-tech w-25">
              <img src={imageTeaser} alt="Solar panels" />
            </div>
          </div>
        </div>

        <Footer />
      </div>

      <div className="page-break"></div>
      <div className="pdf-page-content">
        <div style={{ flex: 1 }}>
          <Header />
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column gap-3 w-75 padding-left-top-rigth">
              <MainInfoTeaser />
              <div className="d-flex flex-column gap-2">
                <CapexAndOpexInfo />
                <SellerServices />
                <TransactionDealFlow />
              </div>
            </div>
            <div className="img-tech w-25">
              <img src={imageTeaser} alt="Solar panels" />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
